var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSyncIndicator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1463_10893)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 18,
    r: 17.5,
    fill: "white",
    stroke: "#CBD2D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.25 12V16.5H25.75",
    stroke: "#CBD2D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 24V19.5H18.25",
    stroke: "#CBD2D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6898 15.4162C14.5056 15.9369 14.7783 16.5083 15.2989 16.6925C15.8196 16.8768 16.391 16.6041 16.5752 16.0834L14.6898 15.4162ZM26.77 13.2298L26.0627 13.9367C26.0701 13.9441 26.0776 13.9514 26.0852 13.9586L26.77 13.2298ZM29.5652 17.2286C29.9677 17.6068 30.6006 17.5871 30.9788 17.1846C31.357 16.7821 31.3373 16.1493 30.9348 15.7711L29.5652 17.2286ZM14.4348 18.7711C14.0323 18.3929 13.3994 18.4126 13.0212 18.815C12.6431 19.2175 12.6627 19.8504 13.0652 20.2286L14.4348 18.7711ZM17.23 22.7698L17.9373 22.0629C17.9299 22.0555 17.9224 22.0482 17.9148 22.0411L17.23 22.7698ZM29.3102 20.5834C29.4945 20.0628 29.2217 19.4913 28.7011 19.3071C28.1804 19.1229 27.609 19.3956 27.4248 19.9162L29.3102 20.5834ZM16.5752 16.0834C17.2338 14.2222 18.8013 12.8291 20.7269 12.3934L20.2855 10.4427C17.6901 11.0299 15.5775 12.9076 14.6898 15.4162L16.5752 16.0834ZM20.7269 12.3934C22.6525 11.9577 24.667 12.5404 26.0627 13.9367L27.4773 12.5229C25.5961 10.6408 22.8809 9.85542 20.2855 10.4427L20.7269 12.3934ZM26.0852 13.9586L29.5652 17.2286L30.9348 15.7711L27.4548 12.5011L26.0852 13.9586ZM13.0652 20.2286L16.5452 23.4986L17.9148 22.0411L14.4348 18.7711L13.0652 20.2286ZM16.5227 23.4767C18.4039 25.3588 21.1191 26.1442 23.7145 25.557L23.2731 23.6063C21.3475 24.042 19.333 23.4593 17.9373 22.0629L16.5227 23.4767ZM23.7145 25.557C26.3099 24.9697 28.4225 23.092 29.3102 20.5834L27.4248 19.9162C26.7662 21.7774 25.1987 23.1706 23.2731 23.6063L23.7145 25.557Z",
    fill: "#CBD2D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1463_10893",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1463_10893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1463_10893",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncIndicator);
export default __webpack_public_path__ + "static/media/Sync-indicator.6147b18488725e6c21beb7ea33888bee.svg";
export { ForwardRef as ReactComponent };